module.exports = __webpack_public_path__ + "img/2025-03-06-01-02.5d82da1a.png";